import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpConfigService } from '../core/httpConfig/httpConfigService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  api = this.apiConfig.getBaseUrl;

  activeOrder = new BehaviorSubject(null);

  constructor(private apiConfig: HttpConfigService) {

  }


  parentCheckout(order): Observable<any> {
    return this.apiConfig.post(this.api + "order/parent/checkout", order);
  }
  saveOrder(order): Observable<any> {
    return this.apiConfig.post(this.api + "order/kiosk/save", order);
  }

  createOrder(order): Observable<any> {
    return this.apiConfig.post(this.api + "order/guest/checkout", order);
  }

  getOrderTypes(storeId: number): Observable<any> {
    return this.apiConfig.get(`${this.api}store/${storeId}/orderTypes/qrapp`);
  }

  makeOnlinePayment(onliePaymentModel): Observable<any> {
    return this.apiConfig.post(this.api + 'order/online-payment', onliePaymentModel);
  }

  createOrderByCard(order): Observable<any> {
    return this.apiConfig.post(this.api + 'order/card/checkout', order);
  }


  getOrdersByTableNumber(tableNumber, storeId): Observable<any> {
    const from = this.getCurrentDate().getTime();
    const to = this.getTimeSpanToDays(1).getTime();
    return this.apiConfig.get(this.api + 'order/' + from + '/' + to + '/table/' + tableNumber + '?storeId=' + storeId);
  }



  getTimeSpanToDays(days: number): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const calculatePreviousDate = new Date(today);
    calculatePreviousDate.setDate(calculatePreviousDate.getDate() + days);
    return calculatePreviousDate;
  }
  getCurrentDate(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }


}
